<template>
  <div class="entity-selector-example">
    <h2>Entity Selector Example</h2>

    <base-form
      :schema="formSchema"
      :model-value="formData"
      @submit="handleSubmit"
    >
      Example Form with Entity Selector
    </base-form>

    <v-snackbar
      v-model="showSnackbar"
      :timeout="3000"
      color="success"
    >
      Form submitted successfully!
      <template #action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showSnackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BaseForm from '@/model/baseForm/BaseForm/BaseForm.vue'
import { createEntitySelectorSchema } from './entitySelectorUtils'

export default {
  name: 'EntitySelectorExample',
  components: {
    BaseForm
  },
  data () {
    return {
      formData: {
        category: null,
        name: '',
        description: ''
      },
      showSnackbar: false
    }
  },
  computed: {
    formSchema () {
      return [
        createEntitySelectorSchema({
          key: 'category',
          name: 'Category',
          hint: 'Select a category or create a new one',
          loadFunction: this.loadCategories,
          addFunction: this.addCategory,
          formSchemas: this.categoryFormSchema
        }),
        {
          key: 'name',
          name: 'Name',
          component: 'v-text-field',
          required: true,
          hint: 'Enter the name'
        },
        {
          key: 'description',
          name: 'Description',
          component: 'v-textarea',
          required: false,
          hint: 'Enter a description',
          fullWidth: true
        }
      ]
    },
    categoryFormSchema () {
      return [
        {
          key: 'name',
          name: 'Category Name',
          component: 'v-text-field',
          required: true,
          hint: 'Enter the category name'
        },
        {
          key: 'description',
          name: 'Category Description',
          component: 'v-textarea',
          required: false,
          hint: 'Enter a category description',
          fullWidth: true
        }
      ]
    }
  },
  methods: {
    // Example function to load categories
    async loadCategories () {
      // In a real application, this would fetch data from an API
      // For this example, we'll return mock data
      await new Promise(resolve => setTimeout(resolve, 1000)) // Simulate API delay

      return [
        { id: 1, name: 'Category 1', description: 'Description for Category 1' },
        { id: 2, name: 'Category 2', description: 'Description for Category 2' },
        { id: 3, name: 'Category 3', description: 'Description for Category 3' }
      ]
    },

    // Example function to add a new category
    async addCategory (categoryData) {
      // In a real application, this would send data to an API
      // For this example, we'll simulate creating a new category
      await new Promise(resolve => setTimeout(resolve, 1000)) // Simulate API delay

      // Create a new category with a random ID
      const newCategory = {
        id: Math.floor(Math.random() * 1000) + 4,
        ...categoryData
      }

      console.log('New category created:', newCategory)
      return newCategory
    },

    // Handle form submission
    handleSubmit (formData) {
      console.log('Form submitted with data:', formData)
      this.showSnackbar = true
    }
  }
}
</script>

<style scoped>
.entity-selector-example {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
</style>
